import React from "react";
import { Box, Typography, Grid, Paper, Button, Container } from "@mui/material";
import { Helmet } from "react-helmet-async";
import AnalyticsTracker from "../GASetup/AnalyticsTracker";
import CTA from "../Homepage/CTA";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
  semiBoldFonts,
} from "../../Styles/Styles";

const About = () => {
  return (
    <>
      <Container maxWidth="lg" sx={{ minHeight: "100vh", mt: 4, mb: 5 }}>
        <Helmet>
          <title>About - Listed.ky</title>
          <meta name="description" content="About - Listed.ky" />
        </Helmet>
        <AnalyticsTracker />

        {/* Hero Section */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              ...semiBoldFonts,
              letterSpacing: 2,
              color: "var(--primary-color)",
              textTransform: "uppercase",
              position: "relative",
              display: "inline-block",
              paddingBottom: "8px",
              "&::after": {
                content: '""',
                width: "80px",
                height: "4px",
                backgroundColor: "var(--primary-color)",
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%)",
              },
            }}
          >
            About Listed.ky
          </Typography>
          <Typography
            variant="body1"
            sx={{
              ...fonts,
              color: "text.secondary",
              maxWidth: "800px",
              margin: "auto",
            }}
          >
            Listed.ky is a premier online marketplace designed to make buying
            and selling simple, safe, and accessible for everyone. Founded on
            the principles of trust, transparency, and convenience, our platform
            connects a diverse community of users looking to exchange goods and
            services seamlessly. Whether you’re a seasoned seller or a
            first-time buyer, Listed.ky provides a user-friendly experience that
            helps you find what you need with confidence. We are continually
            evolving to meet the needs of our users, integrating innovative
            features that enhance accessibility and security. Join our growing
            community and discover a better way to buy and sell online.
          </Typography>
        </Box>

        {/* Info Cards */}
        <Grid container spacing={4} justifyContent="center">
          {[
            {
              title: "Our Story",
              text: "Founded in 2014, Listed.ky started as a small local platform and has grown into a trusted marketplace serving thousands of users. Our journey has been fueled by innovation, customer feedback, and a passion for creating value.",
            },
            {
              title: "Our Mission",
              text: "We aim to connect buyers and sellers in a safe, efficient, and user-friendly manner. Our goal is to empower users through technology and provide exceptional service for a seamless experience.",
            },
            {
              title: "Our Values",
              text: "At Listed.ky, our core values shape everything we do. We believe in Integrity, Customer Focus, Innovation, and Community, ensuring trust and satisfaction for all our users.",
            },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
                elevation={3}
                sx={{
                  padding: 4,
                  height: "100%",
                  textAlign: "center",
                  borderRadius: "12px",
                  ...cardOutline,
                  ...cardHover,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    ...headingFonts,
                    color: "var(--secondary-color)",
                    mb: 2,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    ...fonts,
                    color: "text.secondary",
                  }}
                >
                  {item.text}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
      <CTA />
    </>
  );
};

export default About;
